module.exports = __webpack_public_path__ + "img/J12809.e63a1ca7.png";